import { getExchangePickList } from "../ExchangeServingList/utils";
import { useApolloResolverContext } from "../hooks/useApolloResolverContext";
import { useServingAmountsWithExchangeTotals } from "./utils";
import { mergeServingAmounts } from "../ServingAmount/utils";
import { sortExchangeFn } from "../Exchange/utils";
export const useExchangeTargets = ({ targetExchangeAmounts, servingAmounts, exchangeSet, onEditServingAmounts, }) => {
    const context = useApolloResolverContext();
    const servingAmountsWithExchangeTotals = useServingAmountsWithExchangeTotals(servingAmounts, exchangeSet, targetExchangeAmounts, context);
    const unassignedServingAmounts = servingAmountsWithExchangeTotals
        .filter(({ exchangeTotals }) => {
        return Object.keys(exchangeTotals).every(exchangeId => exchangeTotals[exchangeId] === undefined);
    })
        .map(({ servingAmount }) => servingAmount);
    const exchangeTargets = exchangeSet.exchanges
        .flatMap(exchange => {
        const matchingExchangeAmount = targetExchangeAmounts.find(ea => ea.exchange.id === exchange.id);
        const pickList = getExchangePickList(exchange.exchangeServingList, matchingExchangeAmount?.pickListServingIds || null);
        const servingAmountsWithExchangeAmount = servingAmountsWithExchangeTotals
            .map(({ servingAmount, exchangeTotals }) => ({
            ...servingAmount,
            exchangeAmount: exchangeTotals[exchange.id],
        }))
            .flatMap(sa => (sa.exchangeAmount === undefined ? [] : { ...sa, exchangeAmount: sa.exchangeAmount }));
        const exchangeTargetAmount = matchingExchangeAmount?.amount || 0;
        if (exchangeTargetAmount === 0 && servingAmountsWithExchangeAmount.length === 0) {
            return [];
        }
        else {
            return {
                amount: exchangeTargetAmount,
                exchange,
                pickList,
                servingAmountsWithExchangeAmount,
            };
        }
    })
        .sort((ea1, ea2) => {
        const ea1IsEmpty = ea1.servingAmountsWithExchangeAmount.length === 0;
        const ea2IsEmpty = ea2.servingAmountsWithExchangeAmount.length === 0;
        if (ea1IsEmpty === ea2IsEmpty) {
            return sortExchangeFn(ea1.exchange, ea2.exchange);
        }
        else if (ea1IsEmpty) {
            return -1;
        }
        else {
            return 1;
        }
    });
    const onChangeExchangeTargetServingAmounts = (exchangeTarget, newServingAmounts) => {
        const replaceServingIds = exchangeTarget.servingAmountsWithExchangeAmount.map(sa => sa.serving.id);
        onEditServingAmounts(mergeServingAmounts([...servingAmounts.filter(sa => !replaceServingIds.includes(sa.serving.id)), ...newServingAmounts]));
    };
    return {
        exchangeTargets,
        onChangeExchangeTargetServingAmounts,
        unassignedServingAmounts,
    };
};
//# sourceMappingURL=useExchangeTargets.js.map